var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('base-banner',{attrs:{"id":"19"}}),_c('base-detail',{attrs:{"title":_vm.detail.title,"date":_vm.detail.date,"content":_vm.detail.content}}),_c('div',{staticClass:"status"},[_vm._v("处理状态："+_vm._s(_vm.detail.status))]),_c('div',{staticClass:"status"},[_vm._v("处理结果："+_vm._s(_vm.detail.reply))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }